import { post, fetch, patch, put } from './Api.js'

const getToken = (url, data) => {
    return post(url, data)
        // .then((response) => {
        //     //console.log(response)
        // })
}
const localHistoryInfo = (data) => {
    return post('api/localHistoryInfo', data)
        // .then((response) => {
        //     //console.log(response)
        // })
}
const request = (url, data, config) => {
    return post(url, data, config);
}

export { getToken, localHistoryInfo, request }